import { MasterScheduleManpowerStateTypes, MasterScheduleManpowerActionTypes } from "./MasterScheduleManpower.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MasterScheduleManpowerStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const MasterScheduleManpowerReducer = (
  state: MasterScheduleManpowerStateTypes = INITIAL_STATE,
  action: any
): MasterScheduleManpowerStateTypes => {
  switch (action.type) {
    case MasterScheduleManpowerActionTypes.FETCH_ALL_MASTER_SCHEDULE_MANPOWER:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MasterScheduleManpowerActionTypes.FETCH_ALL_MASTER_SCHEDULE_MANPOWER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MasterScheduleManpowerActionTypes.FETCH_ALL_MASTER_SCHEDULE_MANPOWER_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MasterScheduleManpowerActionTypes.FETCH_ALL_MASTER_SCHEDULE_MANPOWER_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case MasterScheduleManpowerActionTypes.FETCH_ONE_MASTER_SCHEDULE_MANPOWER:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MasterScheduleManpowerActionTypes.FETCH_ONE_MASTER_SCHEDULE_MANPOWER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MasterScheduleManpowerActionTypes.FETCH_ONE_MASTER_SCHEDULE_MANPOWER_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MasterScheduleManpowerActionTypes.FETCH_ONE_MASTER_SCHEDULE_MANPOWER_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MasterScheduleManpowerReducer;
